import { useCallback, useEffect } from "react";

import { isMacLike } from "@/utils/platform";

/**
 * Listens for Cmd+K (macOS) / Ctrl+K (Windows/Linux) to toggle the command palette.
 */
export const useCommandPaletteShortcut = (onToggle: () => void) => {
    const handleKeyDown = useCallback(
        (event: KeyboardEvent) => {
            if (event.key !== "k") {
                return;
            }
            if (isMacLike() ? event.metaKey : event.ctrlKey) {
                if (event.defaultPrevented) {
                    return;
                }
                event.preventDefault();
                onToggle();
            }
        },
        [onToggle],
    );

    useEffect(() => {
        document.addEventListener("keydown", handleKeyDown);
        return () => {
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [handleKeyDown]);
};
